import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';
import { OpenAskAiState, pluginKey, setOpenAskAi } from '../openAskAiUtils';
import { getExtensionOption } from '../private/utils/getExtensionOption';

export const openAskAiExtension = Extension.create<never, OpenAskAiState>({
  name: 'openAskAi',
  addStorage() {
    return {
      open: false,
    };
  },
  addKeyboardShortcuts(this) {
    return {
      ' ': () => {
        if (
          getExtensionOption(this.editor, 'aiPromptOptions').enableSpaceForAi
        ) {
          const { view } = this.editor;
          const { from } = this.editor.state.selection;
          const node = this.editor.state.doc.resolve(from).parent;

          if (node.childCount === 0) {
            setOpenAskAi(view, { open: true });
            setTimeout(() => {
              //remove space after event listened
              const tr = view.state.tr;
              tr.delete(from, from + 1);
              view.dispatch(tr);
            }, 1);
          }
        }
        return false;
      },
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: pluginKey,
        state: {
          init() {
            return {
              open: false,
              nodePos: undefined,
            };
          },
          apply(tr, value) {
            const newPluginState = tr.getMeta(pluginKey);
            return newPluginState || value;
          },
        },
      }),
    ];
  },
});
